<div class="status-bar-content">
    <span class="material-symbols-sharp status-bar-icon">
        {{$statusIcon()}}
    </span>
    {{$status()}}
</div>
@if ($showProgress()) {
    <div class="status-bar-progress-track">
        @for (animationKey of [$progressAnimationKey()]; track animationKey) {
            <div class="status-bar-progress-fill"
                [style.animation-duration.ms]="$delay()"></div>
        }
    </div>
}
